import { RuleResult } from 'types/DeclarationP5'
import { CL112_CTC_COUNTRIES } from 'shared/ncts/common/constants'

const C0821Validator = {
  validateCombinedNomenclatureCodeRequirement: ({
    country,
  }: {
    country?: string | null
  }): RuleResult => {
    if (country && CL112_CTC_COUNTRIES.includes(country ?? '')) {
      return 'NOT_ALLOWED'
    }

    return 'OPTIONAL'
  },
} as const

export default C0821Validator
